import type { ComponentProps } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { FooterCreateButtons as FooterCreateButtonsComponent } from '@confluence/create-blank-fabric-page/entry-points/FooterCreateButtons.ts';

// LoadablePaint (not the sunset LoadableAfterPaint) is the correct phase for this page-tree footer
// widget.
export const FooterCreateButtons: LoadableType<
	ComponentProps<typeof FooterCreateButtonsComponent>
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FooterCreateButtons" */ '@confluence/create-blank-fabric-page/entry-points/FooterCreateButtons.ts'
			)
		).FooterCreateButtons,
});
